module.exports = __webpack_public_path__ + "static/media/marketing.cf1f9eef.png";